function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "17",
  height: "17",
  viewBox: "0 0 17 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_5696_3209)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.923.54H3.077A2.577 2.577 0 00.5 3.115v10.846a2.577 2.577 0 002.577 2.577h10.846a2.577 2.577 0 002.577-2.577V3.116A2.577 2.577 0 0013.923.54z",
  fill: "#2867B2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.98 4.465a1.22 1.22 0 10-2.296-.823 1.22 1.22 0 002.295.823zM14.388 14.243h-2.191V9.527c0-.544-.046-.853-.307-1.128-.262-.275-.617-.46-1.139-.448-.676.017-1.223.332-1.398.798-.084.224-.13.67-.13.876 0 .252-.018.602-.018.816v3.802h-2.19v-7.81h2.02V7.51c.606-1.137 1.463-1.463 2.583-1.463.755 0 1.556.289 2.078.82.494.503.692 1.34.692 2.488v4.888zM4.926 6.434h-2.19v7.81h2.19v-7.81z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_5696_3209"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(.5 .54)",
  d: "M0 0h16v16H0z"
})))));